module.exports = __webpack_public_path__ + "static/media/rotaView2.f4804369.svg";